import { UnitTransferDocumentTypeEnumType } from '__generated__/graphql';

export default function unitTransferDocumentTypeToReadable(
  type: UnitTransferDocumentTypeEnumType
): string {
  switch (type) {
    case UnitTransferDocumentTypeEnumType.TransfereePan:
      return 'Transferee PAN Card';
    case UnitTransferDocumentTypeEnumType.TransfereeAadhaar:
      return 'Transferee Aadhaar Card';
    case UnitTransferDocumentTypeEnumType.TransfereeNetWorthCertificate:
      return 'Transferee Net Worth Certificate';
    case UnitTransferDocumentTypeEnumType.TransfereeCoi:
      return 'Transferee Certificate of Incorporation';
    case UnitTransferDocumentTypeEnumType.PersonalInformationSheet:
      return 'Personal Information Sheet';
    case UnitTransferDocumentTypeEnumType.NominationForm:
      return 'Nomination Form';
    case UnitTransferDocumentTypeEnumType.CmlCopy:
      return 'Client Master List (CML) Copy';
    case UnitTransferDocumentTypeEnumType.ReasonEvidence:
      return 'Evidence Supporting Reason for Transfer';
    case UnitTransferDocumentTypeEnumType.GiftDeed:
      return 'Gift Deed';
    case UnitTransferDocumentTypeEnumType.MarriageCertificate:
      return 'Marriage Certificate';
    case UnitTransferDocumentTypeEnumType.DeathCertificate:
      return 'Death Certificate';
    case UnitTransferDocumentTypeEnumType.ValuationReport:
      return 'Valuation Report';
    case UnitTransferDocumentTypeEnumType.StatementOfAccount:
      return 'Statement of Account';
    case UnitTransferDocumentTypeEnumType.Other:
      return 'Other Document';
    default:
      return type;
  }
}
